<!--
 * @Author: congcongpang pangcongcong@bovaesg.com
 * @Date: 2023-10-10 09:36:36
 * @LastEditors: congcongpang pangcongcong@bovaesg.com
 * @LastEditTime: 2023-10-27 20:37:30
 * @FilePath: \official-website\src\components\Footer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="footer" class="container-fluid">
    <!-- <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div> -->
    <div class="footer-container">
      <div class="left" style="margin-top: 40px">
        <img style="width: 400px" src="../assets/img/logo-white.png" alt="" />
        <!-- <p class="title">中國國際可持續發展研究院</p> -->
        <!-- <p class="title">
          China International Sustainability Development Research Institute
        </p> -->
      </div>
      <div class="right" style="margin-top: 40px">
        <p class="address_tel_fax">
          <!-- <span>Address：香港灣仔港灣道26號華潤大廈23樓</span> -->
          <span class="address-label">Address: </span>
          <span class="address-input"
            >Room 2305-2306, 23/F, China Resources Building, 26 Harbour Road,
            Wan Chai, Hong Kong</span
          >
        </p>
        <!-- <p class="address_tel_fax">
          <span>Tel：888-888-888</span>
        </p> -->
        <p class="address_tel_fax">
          <span class="address-label">Email: </span>
          <span class="address-input">
            <p>research@cisdri.org</p>
            <p>pr@cisdri.org</p>
          </span>
        </p>
      </div>
    </div>

    <!-- <p class="email_wx">
      <span>邮箱：xxx@163.com</span>
      <span>微信号：xxx</span>
    </p> -->
    <p class="copy">
      <span
        >Copyright &copy;{{ new Date().getFullYear() }} China International
        Sustainability Development Research Institute</span
      >
      <!-- <span style="margin-left: 30px">Jing ICP Bei No.12132413241</span> -->
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 230px;
  color: #fff;
  background: #2d2926;
  overflow: hidden;
  text-align: center;
  /* position: sticky; */
  /* bottom: 0; */
}
.footer-container {
  display: flex;
  padding: 0 5% 0 5%;
}
.footer-container .left {
  flex: 1;
}
.footer-container .right {
  flex: 1;
  margin-left: 10%;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
  text-align: left;
}
.right {
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
  text-align: left;
  display: flex;
  gap: 10px;
}
.address_tel_fax .address-label {
  flex: 0 0 80px;
  text-align: right;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 20px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue